import applicationRequests from './applications/requests'
import authRequests from './auth/requests'
import convocatoriasRequests from './convocatorias/requests'
import formRequests from './form/requests'
import menuItemsRequest from './menu-items/requests'
import paramsRequests from './params/requests'
import permissionsRequests from './permissions/requests'
import rolesRequests from './roles/requests'
import routesRequests from './routes/requests'
import usersRequests from './users/requests'

const appRequests = {
  Applications: applicationRequests,
  Auth: authRequests,
  Conovatorias: convocatoriasRequests,
  Form: formRequests,
  MenuItems: menuItemsRequest,
  Params: paramsRequests,
  Permissions: permissionsRequests,
  Roles: rolesRequests,
  Routes: routesRequests,
  Users: usersRequests,
}

export default appRequests
